import React from 'react';
import { PersistGate } from 'redux-persist/integration/react'
import RouterAdopta from "./RouterAdopta";
import * as Sentry from "@sentry/react";

class AppAdopta extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            // <Provider store={configStore().store}>
            <PersistGate
                loading={null}
                persistor={this.props.persistor}>

                <RouterAdopta
                    persistor={this.props.persistor}
                    store={this.props.store}
                />
            </PersistGate>
            // </Provider>
        );
    }

    componentWillMount() {
        // this.props.checkIsLogin();
        $(document.body).show();
        $(".loader-container").hide();
        $("#loader").hide();
    }

    componentDidMount() {
    }
}

// function mapStateToProps(state) {
//     console.log("App::mapStateToProps()");
//     return {}
// }

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
// export default connect(mapStateToProps, {checkIsLogin})(App)
// export default Sentry.withProfiler(connect(mapStateToProps, {checkIsLogin})(App))
export default Sentry.withProfiler(AppAdopta)

